import api from "./api";

// 删除播客的音频模板（用户端）
export async function userAudioTemplateDelete({
  audioId,
  agentId
}: { audioId: string; agentId: string }) {
  const res = await api.delete<unknown>(`/user_audio_template/delete`, {
    data: {
      audio_id: audioId,
      agent_id: agentId,
    }
  });
  return res.data;
}
